module.exports = __webpack_public_path__ + "img/icon.424c7eb7.png";